import { useEffect, useState } from 'react'
import { flip, offset, shift, useFloating } from '@floating-ui/react'

import { TimeInput } from '../../../../../../../components/form/time-input/time-input'
import './time.scss'
import {TimeChangePopup} from "../../time-change-popup/time-change-popup";

export type TimeProps = {
  value: string | null
  label: string
  disabled: boolean
  highlighted?: boolean
  handleChange: (value: string) => void
  onPopoverAction?: (itemIds: number[]) => void
  popoverItems?: { key: string; label: string; value: number }[]
  popoverDate?: string
  spName?: string | null
}

export function Time({
  value,
  label,
  disabled,
  highlighted = false,
  handleChange,
  onPopoverAction,
  popoverItems = [],
  popoverDate = '',
  spName = null,
}: TimeProps) {
  const [spIdsToBulkChange, setSpIdsToBulkChange] = useState<number[]>([])
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const { refs, strategy, floatingStyles } = useFloating({
    placement: 'left', // Initial placement
    middleware: [offset(10), flip(), shift()],
  })

  useEffect(() => {
    if (popoverItems.length) {
      setSpIdsToBulkChange(popoverItems.map(item => item.value))
    }
  }, [popoverItems])

  return (
    <div className="ScheduleTime">
      <div ref={refs.setReference} style={{ display: 'inline-block' }}>
        <TimeInput
          disabled={disabled}
          label={label}
          value={value}
          handleChange={val => {
            const prevVal = value
            handleChange(val)
            if (prevVal !== val && popoverItems.length > 0) {
              setIsPopupOpen(true)
            }
          }}
          className={`ScheduleTime__timeInput ${disabled ? 'disabled' : ''} ${highlighted ? 'highlighted' : ''}`}
          useDropdownWithInput
        />
      </div>
      {isPopupOpen && (
        <div
          ref={refs.setFloating} // Reference for the popover positioning
          style={{
            ...floatingStyles,
            position: strategy,
            top: 0,
            left: 0,
            background: 'white',
            borderRadius: '16px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
          }}
        >
          <TimeChangePopup
              popoverItems={popoverItems}
              popoverDate={popoverDate}
              setSpIdsToBulkChange={setSpIdsToBulkChange}
              setIsPopupOpen={setIsPopupOpen}
              spName={spName}
              onPopoverAction={onPopoverAction}
              spIdsToBulkChange={spIdsToBulkChange}
          />
        </div>
      )}
    </div>
  )
}
